import React, { useEffect } from 'react';
import CloseIcon from 'assets/svg/close-icon';

import './modal.styles.scss';

export type ModalProps = {
    visible: boolean,
    title?: string,
    fitMobileScreen?: boolean,
    className?: string,
    onClose?: ()=> void,
};

const Modal: React.FC<ModalProps> = ({ title, visible, onClose, fitMobileScreen = true, children, className = '' }): JSX.Element => {

    useEffect(() => {
        if (visible) {
            window.document.body.classList.add('disable-scroll');
        } else {
            window.document.body.classList.remove('disable-scroll');
        }
    }, [visible]);

    if (!visible) {
        return null;
    }

    return (
        <div className={`c-modal ${className}`}>
            <div className={`c-modal__inner ${fitMobileScreen ? 'fit-mobile' : ''}`.trim()}>
                {onClose && (
                    <div className="c-modal__header body-1">
                        <div>{title}</div>

                        <button type="button" onClick={onClose}>
                            <CloseIcon />
                        </button>
                    </div>
                )}

                <div className="c-modal__body">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;
